<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Triple Menu</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
      <div>Children Count: {{ section.children.length }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex md6 xs12 v-for="child in section.children" :key="child.id">
          <home-feed-triple-menu-child :child="child" :onChildChange="onChildChange" />
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions v-if="expand">
      <v-btn text color="error" @click="deleteSection(section.id)">Remove</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import HomeFeedTripleMenuChild from './HomeFeedTripleMenuChild.vue';
export default Vue.extend({
  components: {
    HomeFeedTripleMenuChild,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
    onChildChange: {
      type: Function,
      required: true,
    },
    deleteSection: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    expand: false,
  }),
});
</script>

<style scoped></style>
